import {connect} from "react-redux";
import VideosPage from "../../../components/Home/Pages/PepiteInfos/Tutos/VideosPage";
import {setSelectedVideo, setShowVideoModal} from "../../../actions/modal";
import {setNavLink} from "../../../actions/setNavLink";
import {setSheetsVideosModalButton,} from "../../../actions/SheetsVideosFormations";

const MapStateToProps = (state) => ({
selectedVideo: state.modal.selectedVideo,
navLink: state.navLink.navLink,
sheetsVideosModalButton: state.sheetsvideosformations.sheetsVideosModalButton,
showVideoModal: state.modal.showVideoModal,
navItem: state.navLink.navItem
});

const MapDispatchToProps = (dispatch) => ({
setSelectedVideo: (url) => {
dispatch(setSelectedVideo(url));
},
setNavLink: (string) => {
dispatch(setNavLink(string));
},
setSheetsVideosModalButton: (bool) => {
dispatch(setSheetsVideosModalButton(bool));
},
setShowVideoModal: (bool) => {
dispatch(setShowVideoModal(bool));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(VideosPage);